
import axios from "axios"

const LOCAL_DEV_HOSTS = new Set(["localhost", "127.0.0.1", "0.0.0.0", "::1"])

const stripTrailingSlash = (value) => (value || "").replace(/\/+$/, "")

const isLocalDevHost = (hostname) => LOCAL_DEV_HOSTS.has(hostname)

const resolveServerURL = (configuredServerURL, browserLocation = typeof window !== "undefined" ? window.location : null) => {
    const fallbackURL = stripTrailingSlash(configuredServerURL)

    if (process.env.NODE_ENV === "production" || !browserLocation || !configuredServerURL) {
        return fallbackURL
    }

    try {
        const serverURL = new URL(configuredServerURL)
        if (isLocalDevHost(serverURL.hostname) && isLocalDevHost(browserLocation.hostname)) {
            serverURL.hostname = browserLocation.hostname
        }
        return stripTrailingSlash(serverURL.toString())
    } catch (error) {
        return fallbackURL
    }
}

const configuredServerURL =
    process.env.NODE_ENV !== "production" ? process.env.VUE_APP_SERVER_URL : process.env.VUE_APP_SERVER_LIVE_URL
const serverURL = resolveServerURL(configuredServerURL)
const baseURL = `${serverURL}/api`
const AUTH_EXPIRED_EVENT_SUPPRESSED_PATHS = ["/auth/logout", "/auth/me"]

const isAuthExpiredEventSuppressed = (config = {}) => {
    const requestUrl = config.url || ""
    return AUTH_EXPIRED_EVENT_SUPPRESSED_PATHS.some((path) => requestUrl.includes(path))
}

const http = axios.create({
    baseURL,
    withCredentials: true,
})

const setHeader = (headers, key, value) => {
    if (typeof headers.set === "function") {
        headers.set(key, value)
        return
    }
    headers[key] = value
}

http.interceptors.request.use((req) => {
    if (req.withCredentials !== false) {
        req.withCredentials = true
    }
    let token = localStorage.getItem("AUTH_TOKEN")
    if (token) {
        req.headers = req.headers || {}
        setHeader(req.headers, "Authorization", `Bearer ${token}`)
    }
    return req
})

http.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response && error.response.status

        if (status === 401) {
            localStorage.removeItem("AUTH_TOKEN")
            if (typeof window !== "undefined" && !isAuthExpiredEventSuppressed(error.config)) {
                window.dispatchEvent(new CustomEvent("auth:expired"))
            }
        }

        return Promise.reject(error)
    }
)

export { http, serverURL, baseURL, resolveServerURL, isAuthExpiredEventSuppressed }
